import React from 'react';

const Background: React.FC = () => {
    return (
        <div className="Background">
        </div>
    );
};
export default Background;